import React, { useRef, useEffect, useCallback, useState} from 'react';
import {PATTERN_SWITCH} from 'session/constants.js';
import {
    selectedParameter,
    getSelectedAutomations} from '../copy.js';
import RowSelection from '../RowSelection.js';
import {DEFAULT_RESOLUTION} from '../constants.js';
import {
    setArrangementCursorStep,
    setSelectedArrangementEvents,
    setArrangementPatternSelected,
    setArrangementRowSelections,
    setAutomationPointsSelected,
} from 'actions/index.js';
import {useYVisible} from './useYVisible.js';
import {useRowSelection} from '../useRowSelection.js';
import MouseHelper from '../MouseHelper.js';
import TrackPatterns from './TrackPatterns.js';
import ParameterAutomation from 'components/automation/ParameterAutomation.js';
import {DEFAULT_WIDTH} from '../constants.js';
import {WIDTH} from 'components/pianoroll/constants.js';
import {connect} from 'react-redux';

const DOUBLE_CLICK_TIME = 200;

const TrackTimeLine = ({
    setPatternSelected,
    width,
    xScale,
    style,
    track,
    wrapperRef,
    isSelectedTrack,
    subSequence,
    yScrollContainer,
    resolution,
    setArrangementRowSelections,
    setAutomationPointsSelected,
    setSelectedEvents,
    setCursorStep,
    bottomMode,
    patternSelected
}) => { 
    const ref = useRef(undefined);
    const lastClick = useRef(0);

    const onClick = useCallback(() => {
        track.sequencerEngine.selectTrack(track.trackNumber);
        let now = new Date().getTime();
        if (now - lastClick.current <= DOUBLE_CLICK_TIME) {
            // show the pattern
            let cursorStep = track.sequencerEngine.state.arrangement.cursorStep;
            let event = track.subSequence.mix.getEvent(PATTERN_SWITCH, cursorStep);
            let events = {};
            events[event.id] = event;
            setSelectedEvents(events);
            setPatternSelected(event);
            setCursorStep(event.step);
        }
        lastClick.current = now;
    }, [track]);

    const {onRowSelectionUp, onRowSelectionDown, onRowSelectionMove} =
          useRowSelection({
              id: track.id,
              sequencerEngine: track.sequencerEngine,
              xScale: xScale,
              resolution: resolution,
              setArrangementRowSelections: setArrangementRowSelections,
              scrollContainer: wrapperRef
          });

    useYVisible({
        verticalScroll: yScrollContainer,
        ref,
        isSelected: isSelectedTrack,
        patternSelected,
        bottomMode
    });

    const onMouseUp = useCallback((e) => {
        onRowSelectionUp();

        let engine = track.sequencerEngine;
        let state = engine.state;
        // find selected parameters if necessary
        let rowSelection = state.arrangement.rowSelections[track.id];
        let parameter = selectedParameter(engine, track.id);
        if (parameter && rowSelection) {
            let automations = getSelectedAutomations(
                engine,
                rowSelection,
                track.id);

            setAutomationPointsSelected(
                track.id,
                automations);
        }
        
    }, [track]);

    return (
        <div
          ref={ref}
          onMouseDown={onRowSelectionDown}
          onMouseMove={onRowSelectionMove}
          onMouseUp={onMouseUp }
          onClick={onClick}
          style={style} className={isSelectedTrack ? "selected track-time-line" : "track-time-line"}>
          <RowSelection id={track.id}/>
          {isSelectedTrack ?
           <MouseHelper subSequence={track.subSequence} isSelected={true}/> : ''}
           <TrackPatterns
             wrapperRef={wrapperRef}
             track={track} subSequence={subSequence}/>
          <ParameterAutomation
            xScale={xScale / (5.76 / 2.0)} 
            wrapperRef={wrapperRef}
            left={140}
            track={track}
            isMix={true}
            height={62}
            width={width}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let isSelectedTrack = state.mix.selectedTrack === props.track.trackNumber; 
    let currentSubSequence = props.track.sequencerEngine.currentSubSequence;
    return {
        xScale: state.arrangement.xScale,
        isSelectedTrack: isSelectedTrack && props.track.subSequence === currentSubSequence,
        resolution: DEFAULT_RESOLUTION,
        patternSelected: state.arrangement.patternSelected,
        bottomMode: state.arrangement.bottomMode
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setArrangementRowSelections: (selections) => dispatch(
          setArrangementRowSelections(selections)),
      setAutomationPointsSelected: (id, events) =>
          dispatch(setAutomationPointsSelected(id, events)),
      setPatternSelected: p => dispatch(setArrangementPatternSelected(p)),
      setSelectedEvents: (events) => dispatch(
          setSelectedArrangementEvents(events)),
      setCursorStep: (x) => dispatch(
          setArrangementCursorStep(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackTimeLine);
